export default "__VITE_ASSET__270b5c83__"